export default __webpack_public_path__ + "static/media/iconGoogle.6e318d59.svg";